'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _RequestStatusTypes = require('conversations-schema/constants/RequestStatusTypes');

var RequestStatusTypes = _interopRequireWildcard(_RequestStatusTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = (0, _immutable.Record)({
  messagesFetchStatus: RequestStatusTypes.UNINITIALIZED,
  conversationsFetchStatus: RequestStatusTypes.UNINITIALIZED,
  initialConversationFetchStatus: RequestStatusTypes.UNINITIALIZED,
  conversationsFilterStatus: RequestStatusTypes.UNINITIALIZED,
  messageUpdateStatus: RequestStatusTypes.UNINITIALIZED,
  userSettingsFetchStatus: RequestStatusTypes.UNINITIALIZED,
  userSettingsUpdateStatus: RequestStatusTypes.UNINITIALIZED,
  portalSettingsFetchStatus: RequestStatusTypes.UNINITIALIZED,
  portalSettingsUpdateStatus: RequestStatusTypes.UNINITIALIZED,
  sendVisitorEmailAddressStatus: RequestStatusTypes.UNINITIALIZED,
  fetchContactStatus: RequestStatusTypes.UNINITIALIZED,
  usersFetchStatus: RequestStatusTypes.UNINITIALIZED,
  teamsFetchStatus: RequestStatusTypes.UNINITIALIZED,
  meetingsLinksFetchStatus: RequestStatusTypes.UNINITIALIZED,
  snippetsFetchStatus: RequestStatusTypes.UNINITIALIZED,
  smartListsFetchStatus: RequestStatusTypes.UNINITIALIZED,
  widgetData: RequestStatusTypes.UNINITIALIZED,
  serverTimeOffsetStatus: RequestStatusTypes.UNINITIALIZED,
  agentStatus: RequestStatusTypes.UNINITIALIZED,
  chatHistoryFetchStatus: (0, _immutable.Map)(),
  threadListStatus: RequestStatusTypes.UNINITIALIZED,
  installedIntegrationFetchStatus: RequestStatusTypes.UNINITIALIZED,

  fetchConnectedAccounts: RequestStatusTypes.UNINITIALIZED,
  channelsFetchStatus: RequestStatusTypes.UNINITIALIZED,
  fetchUnknownResponders: RequestStatusTypes.UNINITIALIZED,
  connectedAccountUpdateStatus: RequestStatusTypes.UNINITIALIZED
}, 'DeprecatedRequestStatus');
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-schema/static-1.4266/js/deprecated-request-status/records/DeprecatedRequestStatus.js
// module id = 864
// module chunks = 2 3